module.exports = __webpack_public_path__ + "static/img/gylimg.95055406.png";